export type ImageKeywordError = 'invalidCharacters' | 'tooMany' | 'tooLong'

export function parseImageKeywords(input: string): {
  keywords: string[]
  error?: ImageKeywordError
} {
  const keywords = [...new Set(input.split(/[\s,]+/).filter(Boolean))]
  if (keywords.some((keyword) => !/^[A-Za-z0-9_.-]+$/.test(keyword))) {
    return { keywords, error: 'invalidCharacters' }
  }
  if (keywords.length > 5) return { keywords, error: 'tooMany' }
  if ([...JSON.stringify(keywords)].length > 100) return { keywords, error: 'tooLong' }
  return { keywords }
}
